import React from 'react';

const StaticPageLayout = ({ title, subtitle, children }) => {
  return (
    <>
      {/* Page Header */}
      <div className="tw-bg-gradient-to-r tw-from-primary-600 tw-to-primary-800 tw-py-16 md:tw-py-20">
        <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
          <h1 className="tw-text-4xl tw-text-white tw-m-0">{title}</h1>
          {subtitle && (
            <p className="tw-text-lg tw-text-primary-200 tw-mt-3 tw-mb-0 tw-max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-12 md:tw-py-16">
        <div className="tw-max-w-4xl">
          {children}
        </div>
      </div>
    </>
  );
};

export default StaticPageLayout;
